import { useMemo } from 'react'
import { ICONE } from 'icons'
import { BaseSelectModal } from 'inputs'
import { useEntita } from '../entitaGenerica/components/EntitaContext'
import Persona from './Persona'

export default function SincronizzaPersona(props) {
  const { pathPersona, ...restProps } = props

  const {
    infoEntitaPrincipale: { entita },
    gestioneModifica: {
      abilitaPathSincronizzati,
      impostaPathSincronizzati,
    },
    elenchi,
    creaDescrittoriPersone,
  } = useEntita()

  const abilitaPathSincronizzatiPersone = abilitaPathSincronizzati && creaDescrittoriPersone

  const descrittori = useMemo(() => {
    if (!abilitaPathSincronizzatiPersone) return null
    return creaDescrittoriPersone(entita, elenchi).filter(({ path }) => path !== pathPersona)
  }, [abilitaPathSincronizzatiPersone, creaDescrittoriPersone, entita, elenchi, pathPersona])

  if (!abilitaPathSincronizzatiPersone) return null

  function sincronizzaConPersonaCorrente(personaDescrittore) {
    impostaPathSincronizzati(pathPersona, personaDescrittore.path)
  }

  return (
    <BaseSelectModal
      options={descrittori}
      getOptionKey={({ path }) => path}
      renderOption={({ entita }) =>
        <Persona
          persona={entita}
          visioneRiassuntiva
          propsHeader={{ senzaPadding: false }}
        />
      }
      getOptionLabel={({ label }) => label}
      getOptionSearchString={
        ({ entita }) => [entita.nome, entita.cognome].join(' ')
      }
      nonUsareHookForm
      onChange={e => sincronizzaConPersonaCorrente(e.target.value)}

      label='Collega anagrafica'
      propsBottoneModifica={{ iconaInizio: ICONE.CATENA }}
      chipIcon={<ICONE.PERSONA />}
      labelRicerca='nome, cognome'
      {...restProps}
    />
  )
}